/** UI uses binary megabytes consistently with File.size formatting. */
export const MAX_ATTACHMENT_BYTES = 200 * 1024 * 1024;
export const UPLOAD_PART_BYTES = 8 * 1024 * 1024;
